(function () {
    'use strict';
    app.service('adminManagementService', ['$http', '$q', '$rootScope',
    function ($http, $q, $rootScope) {

        var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;
        var deferred;

        this.getData = function () {
            deferred = $q.defer();

            $http.get(serviceBase + "api/super/getData")
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.update = function (approved, pending, rejected) {
            deferred = $q.defer();

            $http.get(serviceBase + "api/super/update?approved=" + approved + "&pending=" + pending + "&rejected=" + rejected)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.senNotificationTodApprovedUsers = function (approvedUsers) {
            deferred = $q.defer();

            return $http({
                method: "POST",
                url: serviceBase + "api/super/notificationToApprovedUsers/",
                dataType: 'json',
                data: approvedUsers,
                headers: { 'Content-Type': 'application/json' }
            }).success(function (data, headers, status) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }
    }
    ]);
})();